import thekhaliqansari from "../Images/thekhaliqansari.png";
import aryansingh from "../Images/aryansingh.jpg";
import rajat from "../Images/rajat.jpg";
import shobhit from "../Images/shobhitgupta.jpg";
import utkarsh from "../Images/utkarsh.jpeg";
import yuvraj from "../Images/yuvraj.jpeg";
const data = [
  {
    id: 1,
    name: "Khaliq Ansari",
    dob: "25-10-2000",
    image: thekhaliqansari,
  },
  {
    id: 2,
    name: "Aryan Singh",
    dob: "05-11-1998",
    image: aryansingh,
  },
  {
    id: 3,
    name: "Shobhit Gupta",
    dob: "21-06-1998",
    image: shobhit,
  },
  {
    id: 4,
    name: "Utkarsh Sharma",
    dob: "25-8-2000",
    image: utkarsh,
  },
  {
    id: 5,
    name: "Yuvraj Singh",
    dob: "20-01-2001",
    image: yuvraj,
  },
  {
    id: 6,
    name: "Rajat Bharadwaj",
    dob: "12-05-1999",
    image: rajat,
  },
];

export default data;